const steps = [
  {
    title: "お問い合わせ",
    text: "お電話（0120-02-4747）またはLINEでお気軽にご相談ください。",
  },
  {
    title: "写真見積り",
    text: "LINEで不用品の写真をお送りいただくだけで、概算のお見積りを無料で提示します。",
  },
  {
    title: "訪問・確定見積り",
    text: "現地で詳細を確認し、確定のお見積りを分かりやすくご提示します。",
  },
  {
    title: "作業日のご予約",
    text: "ご希望の日時に合わせて、作業日を決定します。",
  },
  {
    title: "回収作業",
    text: "分別・搬出・積み込み・清掃まで、スタッフが丁寧に対応します。",
  },
  {
    title: "お支払い・完了",
    text: "作業内容をご確認いただき、お支払いで完了です。",
  },
];

export default function Flow() {
  return (
    <section id="flow" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            FLOW
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            不用品回収の<span className="text-primary-500">作業の流れ</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-bold text-sm shrink-0">
                  {i + 1}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-900">
                  {s.title}
                </h3>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}